import axios from "axios";
import { AuthenticationURL } from "../../Services";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function login(username: string, password: string) {
  ShowAwaiting();
  var res = await axios.post(
    AuthenticationURL + "api/login",
    {
      email: username,
      password: password,
    },
    { withCredentials: true }
  );
  HideAwaiting();
  return res.data;
}
